import { useMemo } from 'react';

import { DEFAULT_TIME_RANGE } from '../constants';
import type { LogLevel, LogType } from '../types';

type FilterParams = {
  pipelineName: string | null;
  pipelineVersion: string | null;
  logMessage: string | null;
  pipelineKey: string | null;
  level: LogLevel;
  logType: LogType;
};

type UseHasActiveFiltersParams = {
  filters: FilterParams;
  time: string;
};

export function useHasActiveFilters({
  filters,
  time
}: UseHasActiveFiltersParams): boolean {
  return useMemo(
    () =>
      Boolean(
        filters.pipelineName ||
        filters.pipelineVersion ||
        filters.logMessage ||
        filters.pipelineKey ||
        (filters.level && filters.level !== 'ALL SEVERITIES') ||
        (filters.logType && filters.logType !== 'ALL SOURCES') ||
        (time && time !== DEFAULT_TIME_RANGE)
      ),
    [
      filters.pipelineName,
      filters.pipelineVersion,
      filters.logMessage,
      filters.pipelineKey,
      filters.level,
      filters.logType,
      time
    ]
  );
}
